import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import { Page } from '@/core/architecture'

import { ConsoleItemEditTemplate } from './template'
import { useViewModel } from './viewModel'

export const ConsoleItemEdit: Page = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Component />
    </DndProvider>
  )
}

/**
 * ConsoleItemEdit Page
 * Implemented as a practical sample.
 */
export const Component: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleItemEditTemplate state={state} {...actions} />
}
